module.exports = __webpack_public_path__ + "img/echoing_blue_whale.dd07965a.png";